module.exports = __webpack_public_path__ + "static/media/hands_25.94cda841.svg";